 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML9780226322735_01_COVER from '@/components/html/9780226322735_01_cover'
 import HTML9780226322735_05_COPY from '@/components/html/9780226322735_05_copy'
 import HTML9780226322735_04_TIT from '@/components/html/9780226322735_04_tit'
 import HTML9780226322735_02_PRAISE from '@/components/html/9780226322735_02_praise'
 import HTML9780226322735_03_FM from '@/components/html/9780226322735_03_fm'
 import HTML9780226322735_06_TOC from '@/components/html/9780226322735_06_toc'
 import HTML9780226322735_07_MAP from '@/components/html/9780226322735_07_map'
 import HTML9780226322735_08_PREF from '@/components/html/9780226322735_08_pref'
 import HTML9780226322735_09_ACK from '@/components/html/9780226322735_09_ack'
 import HTML9780226322735_10_CH1 from '@/components/html/9780226322735_10_ch1'
 import HTML9780226322735_11_CH2 from '@/components/html/9780226322735_11_ch2'
 import HTML9780226322735_12_CH3 from '@/components/html/9780226322735_12_ch3'
 import HTML9780226322735_13_CH4 from '@/components/html/9780226322735_13_ch4'
 import HTML9780226322735_14_CH5 from '@/components/html/9780226322735_14_ch5'
 import HTML9780226322735_15_CH6 from '@/components/html/9780226322735_15_ch6'
 import HTML9780226322735_16_CH7 from '@/components/html/9780226322735_16_ch7'
 import HTML9780226322735_17_CH8 from '@/components/html/9780226322735_17_ch8'
 import HTML9780226322735_18_CH9 from '@/components/html/9780226322735_18_ch9'
 import HTML9780226322735_19_APPA from '@/components/html/9780226322735_19_appa'
 import HTML9780226322735_20_APPB from '@/components/html/9780226322735_20_appb'
 import HTML9780226322735_21_APPC from '@/components/html/9780226322735_21_appc'
 import HTML9780226322735_22_APPD from '@/components/html/9780226322735_22_appd'
 import HTML9780226322735_23_APPE from '@/components/html/9780226322735_23_appe'
 import HTML9780226322735_24_APPF from '@/components/html/9780226322735_24_appf'
 import HTML9780226322735_25_APPG from '@/components/html/9780226322735_25_appg'
 import HTML9780226322735_26_GLOS from '@/components/html/9780226322735_26_glos'
 import HTML9780226322735_27_GLOST from '@/components/html/9780226322735_27_glost'
 import HTML9780226322735_28_NOTREF from '@/components/html/9780226322735_28_notref'
 import HTML9780226322735_29_BIB from '@/components/html/9780226322735_29_bib'
 import HTML9780226322735_30_AFT from '@/components/html/9780226322735_30_aft'
 import HTML9780226322735_31_INDEX from '@/components/html/9780226322735_31_index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9780226322735_06_toc",
 			"name" : "html/9780226322735_06_toc",
 			"component" : HTML9780226322735_06_TOC
 		},
 		{
 			"path" : "/html/9780226322735_07_map",
 			"name" : "html/9780226322735_07_map",
 			"component" : HTML9780226322735_07_MAP
 		},
 		{
 			"path" : "/html/9780226322735_08_pref",
 			"name" : "html/9780226322735_08_pref",
 			"component" : HTML9780226322735_08_PREF
 		},
 		{
 			"path" : "/html/9780226322735_09_ack",
 			"name" : "html/9780226322735_09_ack",
 			"component" : HTML9780226322735_09_ACK
 		},
 		{
 			"path" : "/html/9780226322735_10_ch1",
 			"name" : "html/9780226322735_10_ch1",
 			"component" : HTML9780226322735_10_CH1
 		},
 		{
 			"path" : "/html/9780226322735_11_ch2",
 			"name" : "html/9780226322735_11_ch2",
 			"component" : HTML9780226322735_11_CH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js